<template>
    <header class="ds-main-header">
        <div class="ds-main-header-inner ds-app-shell">
            <div>
                <Logo />
            </div>
            <div>
                <Menu />
            </div>
            <div>
                <Options />
            </div>
        </div>
    </header>
</template>

<script setup lang="ts">
import Menu from './Menu.vue'
import Options from './Options.vue'
</script>
